"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _FeaturedTopic = _interopRequireDefault(require("./FeaturedTopic"));

var _Search = _interopRequireDefault(require("@insided/deprecated-preact-components/algolia/components/Search"));

var _reactSortableHoc = require("react-sortable-hoc");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _classnames = _interopRequireDefault(require("classnames"));

// Too much files to change
var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref) {
  var children = _ref.children;
  return (0, _preact.h)("ul", {
    className: (0, _classnames.default)('sortable-featured-topics-list', 'sortable-curated-topics-list', 'widget-configuration_sortable-deletable-item-list__container')
  }, children);
});
var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref2) {
  var children = _ref2.children;
  return (0, _preact.h)("li", {
    className: (0, _classnames.default)('sortable-featured-topic', 'sortable-curated-topic', 'widget-configuration--sortable-list')
  }, children);
});

var convertFoundTopicToFeaturedTopic = function convertFoundTopicToFeaturedTopic(foundTopic) {
  return {
    id: foundTopic.id,
    title: foundTopic.title,
    url: "".concat((0, _globals.default)('communityUrl')).concat(foundTopic.topic_url),
    contentType: foundTopic.content_type === 'ideation' ? 'idea' : foundTopic.content_type
  };
};

var FeaturedTopicsManager = function FeaturedTopicsManager(_ref3) {
  var onUpdate = _ref3.onUpdate,
      featuredTopics = _ref3.featuredTopics,
      searchPlaceholder = _ref3.searchPlaceholder,
      includeContentTypes = _ref3.includeContentTypes,
      title = _ref3.title,
      description = _ref3.description,
      isSortable = _ref3.isSortable,
      newStyle = _ref3.newStyle,
      newStyleTopic = _ref3.newStyleTopic,
      withoutRedirect = _ref3.withoutRedirect,
      searchWithContentTypes = _ref3.searchWithContentTypes;
  return (0, _preact.h)("div", {
    className: "featured-topics-manager content-curation-manager"
  }, title && (0, _preact.h)("label", null, title), description && (0, _preact.h)("div", {
    className: "featured-topics-manager-description"
  }, description), (0, _preact.h)(SortableList, {
    useDragHandle: true,
    onSortEnd: function onSortEnd(_ref4) {
      var oldIndex = _ref4.oldIndex,
          newIndex = _ref4.newIndex;
      return onUpdate('featuredTopics', (0, _reactSortableHoc.arrayMove)(featuredTopics, oldIndex, newIndex));
    }
  }, featuredTopics.map(function (featuredTopic, idx) {
    return (0, _preact.h)(SortableItem, {
      index: idx,
      key: featuredTopic.id
    }, (0, _preact.h)(_FeaturedTopic.default, {
      title: featuredTopic.title,
      url: featuredTopic === null || featuredTopic === void 0 ? void 0 : featuredTopic.url,
      onDelete: function onDelete() {
        return onUpdate('featuredTopics', featuredTopics.filter(function (t) {
          return t !== featuredTopic;
        }));
      },
      isSortable: isSortable,
      newStyle: newStyleTopic
    }));
  }), (0, _preact.h)(_Search.default, {
    isControl: true,
    newStyle: newStyle,
    searchPlaceholder: searchPlaceholder,
    callback: function callback(foundTopic) {
      return onUpdate('featuredTopics', featuredTopics.concat([convertFoundTopicToFeaturedTopic(foundTopic)]));
    },
    exclude: featuredTopics.map(function (t) {
      return "".concat(t.contentType, "-").concat(t.id);
    }),
    submitIconType: "add",
    searchByContentType: includeContentTypes,
    withoutRedirect: withoutRedirect,
    searchWithContentTypes: searchWithContentTypes
  })));
};

var _default = FeaturedTopicsManager;
exports.default = _default;